import { Modal } from "react-bootstrap";
import Popup from "../../Helpers/Popup/Popup";
import PopupTitle from "../../Helpers/Popup/PopupParts/PopupTitle";
import trans from "../../../utils";
import Close from "../../Helpers/CloseBtn/Close";
import Button from "../../Helpers/Button/Button";
import { Formik, Form as FormFormik } from "formik";
import * as Yup from "yup";
import { TextAreaInput } from "../../Helpers/Input/Input";
import FileUploader from "../../Helpers/Dropzone/FileUploader";
import { useDisputeSnagMutation } from "../../../Redux/service/Snag/Snag";
import { toast } from "react-toastify";
import { useContext } from "react";
import { popupcontext } from "../../../context/Popupscontext";

const DisputePopup = ({ show, setShow, snagId, onSuccess }) => {
  const { setEdited } = useContext(popupcontext);
  const [disputeSnag, { isLoading }] = useDisputeSnagMutation();

  const initialValues = {
    comments: "",
    files: [],
  };

  const validationSchema = Yup.object({
    comments: Yup.string().required(trans("Dispute reason is required")),
  });

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const formData = new FormData();
      formData.append("comments", values.comments);

      if (values.files && Array.isArray(values.files)) {
        values.files.forEach((file) => {
          if (file instanceof File) {
            formData.append("attachments", file);
          }
        });
      }

      await disputeSnag({ id: snagId, formData }).unwrap();
      toast.success(trans("Snag marked as disputed successfully"), {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar" ? true : false,
      });

      resetForm();
      setShow(false);
      setEdited(true);
      if (onSuccess) {
        onSuccess();
      }
    } catch (err) {
      let errorMsg = trans(
        err?.data?.message ||
          err?.response?.data?.message ||
          err?.message ||
          "Something went wrong"
      );
      toast.error(errorMsg, {
        autoClose: 800,
        rtl: localStorage.getItem("lang") === "ar" ? true : false,
      });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Popup show={show} size={"md"}>
      <Modal.Header className="modal-header flex-between">
        <Modal.Title id="contained-modal-title-vcenter">
          <PopupTitle headtitle={trans("Mark as Disputed")} />
        </Modal.Title>
        <Close
          style="close-32 close"
          close={() => setShow(false)}
          img="Close"
        />
      </Modal.Header>
      <Modal.Body className="modal-body-scrollable">
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            values,
            setFieldValue,
            handleSubmit,
            isSubmitting,
            errors,
            touched,
          }) => (
            <FormFormik onSubmit={handleSubmit}>
              <div className="form-section">
                <div className="row">
                  <div className="col-lg-12">
                    <TextAreaInput
                      title={trans("Dispute Reason")}
                      id="comments"
                      name="comments"
                      rows={5}
                      placeholder={trans("Explain the reason for dispute")}
                      value={values.comments}
                      onChange={(e) =>
                        setFieldValue("comments", e.target.value)
                      }
                      errors={errors.comments}
                      touched={touched.comments}
                      required={true}
                    />
                  </div>
                  <div className="col-lg-12 mt-3">
                    <FileUploader
                      file={values.files}
                      onFileSelect={(files) => setFieldValue("files", files)}
                      multiple={true}
                      sizeMB={10}
                      label={trans("Upload Supporting Documents (Optional)")}
                    />
                  </div>
                </div>
              </div>
              <Modal.Footer>
                <div className="popups-footer gap-8">
                  <Button
                    type="default"
                    htmlType="submit"
                    loading={isSubmitting || isLoading}
                    disabled={isSubmitting || isLoading}
                  >
                    {isSubmitting || isLoading
                      ? trans("Submitting...")
                      : trans("Mark as Disputed")}
                  </Button>
                  <Button
                    type="default"
                    htmlType="button"
                    disabled={isSubmitting || isLoading}
                    onClick={() => setShow(false)}
                  >
                    {trans("Cancel")}
                  </Button>
                </div>
              </Modal.Footer>
            </FormFormik>
          )}
        </Formik>
      </Modal.Body>
    </Popup>
  );
};

export default DisputePopup;